import {useAppSelector} from '@/hooks';
import {useGetFabricObjectPropertiesMap} from './useGetFabricObjectPropertiesMap';
import type {FabricObjectPositionOrDimensionKeys} from '@Components/poster-editor/components/custom-item-controls/custom-item-controls.types';
import {SelectionType} from '@Components/poster-editor/components/custom-item-controls/custom-item-controls.types';
import type {FabricObject} from '@postermywall/fabricjs-2';

export function useGetItemsFabricObjectPositionOrDimensionKeysMap(
  pageHashedId: string,
  selection: SelectionType = SelectionType.SINGLE_ITEM_SELECTION
): Record<string, FabricObjectPositionOrDimensionKeys> | undefined {
  const posterScale = useAppSelector((state) => state.posterEditor?.posterObject?.scaling.scale);

  const keys = ['width', 'height', 'scaleX', 'scaleY', 'angle', 'left', 'top', 'strokeWidth', 'borderScaleFactor'] as (keyof FabricObject)[];

  const propsMap = useGetFabricObjectPropertiesMap(pageHashedId, keys, selection);

  if (!posterScale || !propsMap) {
    return undefined;
  }

  const result: Record<string, FabricObjectPositionOrDimensionKeys> = {};

  for (const [id, props] of Object.entries(propsMap)) {
    result[id] = {
      ...props,
      scaledWidth: props.width * props.scaleX + props.strokeWidth,
      scaledHeight: props.height * props.scaleY + props.strokeWidth,
      posterScale,
    };
  }

  return result;
}
